import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import CohortBinsDropdownItems from './CohortBinsDropdownItems';

const CohortBinsDropdown = ({ value, disabled, onChange }) => {
  const intl = useIntl();
  return (
    <Dropdown
      item
      className="aridhia-cohort-bins-dropdown"
      disabled={disabled}
      text={intl.formatMessage({ id: 'cohorts.visualisation.bins.select' }, { bin: value })}
    >
      <Dropdown.Menu>
        <Dropdown.Header content={intl.formatMessage({ id: 'cohorts.visualisation.bins.select.header' })} />
        <CohortBinsDropdownItems value={value} onChange={onChange} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CohortBinsDropdown;
